<div class="rich-text-container" (lcClickOutside)="onClickedOutside()">
  <div class="lc-rich-text html-enabled" [class.border]="showValidationBorder"
    [class.border-primary]="showValidationBorder && textFits && !isEmoji">
    <div [class.border-warn]="!textFits || isEmoji" [class.text-overflow]="!textFits">
      <lc-editor-control
        [disabled]="readonly"
        [errorState]="hasErrors"
        [formControl]="formControl"
        [format]="format"
        [isContact]="isContact"
        [isHeader]="isHeader"
        [minimumHeight]="minimumHeight"
        [richTextEnabled]="richTextEnabled"
        [setBorder]="isRichTextActions"
        [showUndo]="['102'].includes(productCode) || (!['107', '112', '105',].includes(productCode) && bodyIndex === 0)"
        [statistics]="richTextStats"
        [toolbarEnabled]="toolbarEnabled"
        [undoDisabled]="undoDisabled"
        (change)="onTextChange($event)"
        (selectionChange)="onBlur()"
        (undoAiGeneration)="onUndo()"
        />
    </div>
    @if (isRichTextActions) {
      <div class="fx-column border-top bg-card w-100 px-1 pb-1 bg-white">
        <!-- Error messages-->
        <div class="mat-caption line-height-0">
          @if (!textFits) {
            <mat-error class="text-smaller">Text doesn't fit</mat-error>
          }
          @if (isEmoji && textFits) {
            <mat-error class="text-smaller">Emojis are not allowed in the text</mat-error>
          }
          <!-- Placeholder to always reserve this space so that it does not fluctuate in size -->
          <span class="text-smaller">&nbsp;</span>
        </div>
        <div class="editor-actions-btn fx-row y-center" [ngClass]="(aiFeatureIsEnabled$ | async) ? 'x-space-between' : 'x-end'">
          @if (aiFeatureIsEnabled$ | async) {
            <div>
              @if (propertyDescriptionService.getAiMaxRequests(ai); as aiMaxRequests) {
                <p style="margin: 0; font-size: x-small;">
                  AI Usage: {{ propertyDescriptionService.getAiRequests(ai) }} / {{ aiMaxRequests ?? 0 }}
                </p>
              }
              @if (!['107', '112', '105'].includes(productCode) && bodyIndex === 0) {
                <p class="mat-hint" style="margin: 0; font-size: x-small;">
                  AI generated content may contain errors. Verify for accuracy.
                </p>
              }
            </div>
          }
          <div class="fx-row fx-gap-xs">
            <button
              id="btn-cancel"
              mat-raised-button
              (click)="onCancel()"
              >Cancel
            </button>
            <button
              id="btn-save"
              mat-raised-button
              [color]="((aiFeatureIsEnabled$ | async) === false || bodyIndex !== 0 || productCode === ProductCode.CLIENT_REPORT || productCode === ProductCode.JUST_SOLD_POSTCARD) && 'primary'"
              [disabled]="disableSave || !textFits || isEmoji"
              (click)="onSave()"
              >Save
            </button>
            @if ((aiFeatureIsEnabled$ | async) && bodyIndex === 0 && productCode !== ProductCode.CLIENT_REPORT &&  productCode !== ProductCode.JUST_SOLD_POSTCARD) {
              <button
                color="primary"
                id="btn-generate"
                mat-raised-button
                (click)="onGenerate()"
                >Regenerate
              </button>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
